// Structured privacy notices (Italian legal documents — content in IT only).
// Source PDFs: /public/privacy/privacy-clienti.pdf, /public/privacy/privacy-fornitori.pdf

export const PRIVACY_DOCS = {
  clienti: {
    id: "clienti",
    it: { label: "Clienti", short: "Per i clienti" },
    en: { label: "Clients", short: "For clients" },
    fileName: "privacy-clienti.pdf",
    fileUrl: "/privacy/privacy-clienti.pdf",
    title: "Informativa per i clienti",
    subtitle:
      "ai sensi dell'art. 13 del Regolamento (UE) 2016/679 relativo alla protezione delle persone fisiche con riguardo al trattamento dei dati",
    intro:
      "Spett.le Cliente, ai sensi dell'art. 13 del Regolamento dell'Unione Europea n. 2016/679 (di seguito \"Regolamento\"), La informiamo che i dati personali da Lei forniti formeranno oggetto di trattamento nel rispetto della normativa sopra richiamata e delle disposizioni di seguito specificate.",
    sections: [
      {
        n: "1",
        title: "Titolare del trattamento",
        body:
          "È I.E.P.E.M. S.r.l. al cui legale rappresentante pro tempore l'interessato potrà rivolgersi per far valere i Suoi diritti direttamente all'indirizzo di posta elettronica iepem@iepem.it.",
      },
      {
        n: "2",
        title: "Finalità del trattamento",
        items: [
          "Provvedere all'esecuzione degli obblighi dei contratti in essere e/o che saranno in futuro conclusi.",
          "Ottemperare agli obblighi previsti dalla legge per adempimenti amministrativi, fiscali e contabili.",
          "Svolgere attività economiche nel rispetto della vigente normativa in materia di segreto aziendale e industriale, anche mediante operatori terzi.",
        ],
      },
      {
        n: "3",
        title: "Luogo di trattamento",
        body:
          "I dati verranno trattati ed archiviati da I.E.P.E.M. S.r.l. presso la sede legale sita in Strada delle Selvette, n. 2/R, 06134, Perugia.",
      },
      {
        n: "4",
        title: "Ambito di comunicazione e diffusione",
        body:
          "Possono venire a conoscenza dei Suoi dati, per conto del Titolare del Trattamento, professionisti e/o società designati a svolgere attività amministrativo-contabili o di consulenza, in ottemperanza a quanto previsto ex art. 28 del Regolamento (Responsabili esterni) o Persone autorizzate al trattamento, nominate ex art. 29 del Regolamento, individuate per iscritto, cui sono state date specifiche istruzioni scritte. I dati raccolti non saranno mai diffusi e non saranno oggetto di comunicazione senza Suo esplicito consenso, salvo le comunicazioni necessarie che possono comportare il trasferimento di dati ad enti pubblici, a consulenti o ad altri soggetti per l'adempimento degli obblighi di legge.",
      },
      {
        n: "5",
        title: "Modalità di trattamento e conservazione",
        body:
          "Il trattamento sarà svolto in forma automatizzata e/o manuale, nel rispetto di quanto previsto dall'art. 32 del Regolamento in materia di misure di sicurezza, ad opera di soggetti appositamente incaricati e in ottemperanza a quanto previsto dall'art. 29 del Regolamento. I Suoi dati saranno oggetto di trattamento improntato ai principi di correttezza, liceità, trasparenza e di tutela della Sua riservatezza e dei Suoi diritti.",
      },
      {
        n: "6",
        title: "Natura obbligatoria o facoltativa del conferimento dei dati",
        body:
          "Alcuni dati sono indispensabili per l'instaurazione del rapporto contrattuale o per la sua esecuzione, mentre altri si possono definire accessori a tali fini. Il conferimento dei dati al Titolare è obbligatorio per i soli dati per cui è previsto un obbligo normativo o contrattuale.",
      },
      {
        n: "7",
        title: "Trasferimento dati fuori dall'Unione Europea",
        body:
          "Non vengono ordinariamente effettuati trasferimenti di dati all'estero. Laddove venissero trasferiti dati al di fuori dell'Unione Europea questi saranno trattati in conformità agli articoli dal 45 al 49 del Regolamento Europeo 679/2016. L'uso di alcune applicazioni di messaggistica per comunicare con il Titolare del Trattamento (es. WhatsApp) può comportare il trasferimento in paesi extra UE e il trasferimento avviene sulla base di clausole contrattuali tipo, secondo quanto previsto dall'art. 46, par. 2 del GDPR. La scelta di utilizzo di certe applicazioni è volontaria da parte dell'interessato in quanto il Titolare mette a disposizione mezzi di comunicazione alternativi, conformi al GDPR (e-mail, telefono, ecc.). Il conferimento dei suoi dati a soggetti fuori dalla Comunità Europea comporta il rischio che questi non abbiano le stesse garanzie di dati trattati in Europa, ma il Titolare del Trattamento adotterà strumenti per tutelare gli stessi da intrusioni ad opera di terzi.",
      },
      {
        n: "8",
        title: "Conseguenze di un eventuale rifiuto al conferimento",
        body:
          "Nei casi in cui il conferimento dei dati è previsto da un obbligo normativo o contrattuale, l'eventuale rifiuto metterebbe il Titolare nelle condizioni di non poter dare esecuzione o prosecuzione alle finalità previste in quanto costituirebbe un trattamento illecito.",
      },
      {
        n: "9",
        title: "Categorie particolari di dati personali",
        body:
          "Lei potrebbe conferire al Titolare \"categorie particolari di dati personali\" ai sensi dell'art. 9 del Regolamento, cioè quei dati che rivelano \"l'origine razziale o etnica, le opinioni politiche, le convinzioni religiose o filosofiche, o l'appartenenza sindacale, nonché dati genetici, dati biometrici intesi a identificare in modo univoco una persona fisica, dati relativi alla salute o alla vita sessuale o all'orientamento sessuale della persona\". Tali categorie di dati potranno essere trattate solo previo Suo libero ed esplicito consenso.",
      },
      {
        n: "10",
        title: "Esistenza di un processo decisionale automatizzato, compresa la profilazione",
        body:
          "Il Titolare non adotta alcun processo decisionale automatizzato, compresa la profilazione, di cui all'articolo 22 del Regolamento.",
      },
      {
        n: "11",
        title: "Diritti dell'interessato",
        intro:
          "In ogni momento, Lei potrà esercitare, ai sensi degli articoli dal 15 al 22 del Regolamento, il diritto di:",
        items: [
          "chiedere la conferma dell'esistenza o meno di propri dati personali;",
          "ottenere le indicazioni circa le finalità del trattamento, le categorie dei dati personali, i destinatari o le categorie di destinatari a cui i dati personali sono stati o saranno comunicati e, quando possibile, il periodo di conservazione;",
          "ottenere la rettifica e la cancellazione dei dati;",
          "ottenere la limitazione del trattamento;",
          "ottenere la portabilità dei dati, ossia riceverli da un titolare del trattamento, in un formato strutturato, di uso comune e leggibile da dispositivo automatico, e trasmetterli ad un altro titolare del trattamento senza impedimenti;",
          "opporsi al trattamento in qualsiasi momento ed anche nel caso di trattamento per finalità di marketing diretto;",
          "opporsi ad un processo decisionale automatizzato relativo alle persone fisiche, compresa la profilazione;",
          "revocare il consenso in qualsiasi momento senza pregiudicare la liceità del trattamento basata sul consenso prestato prima della revoca;",
          "proporre reclamo a un'autorità di controllo.",
        ],
        footer:
          "Può esercitare i Suoi diritti con richiesta scritta inviata a I.E.P.E.M. S.r.l., all'indirizzo postale della sede legale o all'indirizzo iepem@iepem.it.",
      },
    ],
    place: "Perugia",
    date: "31/08/2026",
  },

  fornitori: {
    id: "fornitori",
    it: { label: "Fornitori", short: "Per i fornitori" },
    en: { label: "Suppliers", short: "For suppliers" },
    fileName: "privacy-fornitori.pdf",
    fileUrl: "/privacy/privacy-fornitori.pdf",
    title: "Informativa per i fornitori",
    subtitle:
      "ai sensi dell'art. 13 del Regolamento (UE) 2016/679 relativo alla protezione delle persone fisiche con riguardo al trattamento dei dati",
    intro:
      "Spett.le Fornitore, ai sensi dell'art. 13 del Regolamento dell'Unione Europea n. 2016/679 (di seguito \"Regolamento\"), La informiamo che i dati personali da Lei forniti formeranno oggetto di trattamento nel rispetto della normativa sopra richiamata e delle disposizioni di seguito specificate. Titolare del trattamento è I.E.P.E.M. S.r.l. al cui legale rappresentante pro tempore l'interessato potrà rivolgersi per far valere i Suoi diritti direttamente all'indirizzo di posta elettronica iepem@iepem.it.",
    sections: [
      {
        n: "1",
        title: "Finalità del trattamento",
        items: [
          "Provvedere all'esecuzione degli obblighi dei contratti in essere e/o che saranno in futuro conclusi.",
          "Ottemperare agli obblighi previsti dalla legge per adempimenti amministrativi, fiscali e contabili.",
          "Svolgere attività economiche nel rispetto della vigente normativa in materia di segreto aziendale e industriale, anche mediante operatori terzi.",
        ],
      },
      {
        n: "2",
        title: "Basi giuridiche",
        items: [
          "Art. 6 par. 1, lett. b) del GDPR — esecuzione obblighi precontrattuali e contrattuali.",
          "Art. 6 par. 1, lett. c) del GDPR — adempimento di un obbligo legale.",
          "Art. 6 par. 1, lett. b) del GDPR — esecuzione obblighi precontrattuali e contrattuali.",
        ],
      },
      {
        n: "3",
        title: "Tempo di conservazione",
        body:
          "10 anni + 1 per tutte le finalità sopra indicate. I tempi di conservazione del dato potrebbero essere prolungati nel caso sia necessario accertare, esercitare o difendere un diritto in sede giudiziaria.",
      },
      {
        n: "4",
        title: "Luogo di trattamento",
        body:
          "I dati verranno trattati ed archiviati da I.E.P.E.M. S.r.l. presso la sede legale sita in Strada delle Selvette, n. 2/R, 06134, Perugia.",
      },
      {
        n: "5",
        title: "Ambito di comunicazione e diffusione",
        body:
          "Possono venire a conoscenza dei Suoi dati, per conto del Titolare del Trattamento, professionisti e/o società designati a svolgere attività amministrativo-contabili o di consulenza, in ottemperanza a quanto previsto ex art. 28 del Regolamento (Responsabili esterni) o Persone autorizzate al trattamento, nominate ex art. 29 del Regolamento, individuate per iscritto, cui sono state date specifiche istruzioni scritte. I dati raccolti non saranno mai diffusi e non saranno oggetto di comunicazione senza Suo esplicito consenso, salvo le comunicazioni necessarie che possono comportare il trasferimento di dati ad enti pubblici, a consulenti o ad altri soggetti per l'adempimento degli obblighi di legge.",
      },
      {
        n: "6",
        title: "Modalità di trattamento e conservazione",
        body:
          "Il trattamento sarà svolto in forma automatizzata e/o manuale, nel rispetto di quanto previsto dall'art. 32 del Regolamento in materia di misure di sicurezza, ad opera di soggetti appositamente incaricati e in ottemperanza a quanto previsto dall'art. 29 del Regolamento. I Suoi dati saranno oggetto di trattamento improntato ai principi di correttezza, liceità, trasparenza e di tutela della Sua riservatezza e dei Suoi diritti.",
      },
      {
        n: "7",
        title: "Natura obbligatoria o facoltativa del conferimento dei dati",
        body:
          "Alcuni dati sono indispensabili per l'instaurazione del rapporto contrattuale o per la sua esecuzione, mentre altri si possono definire accessori a tali fini. Il conferimento dei dati al Titolare è obbligatorio per i soli dati per cui è previsto un obbligo normativo o contrattuale.",
      },
      {
        n: "8",
        title: "Trasferimento dati fuori dall'Unione Europea",
        body:
          "Non vengono effettuati trasferimenti di dati all'estero. Laddove venissero trasferiti dati al di fuori dell'Unione Europea questi saranno trattati in conformità agli articoli dal 45 al 49 del Regolamento Europeo 679/2016.",
      },
      {
        n: "9",
        title: "Conseguenze di un eventuale rifiuto al conferimento",
        body:
          "Nei casi in cui il conferimento dei dati è previsto da un obbligo normativo o contrattuale, l'eventuale rifiuto metterebbe il Titolare nelle condizioni di non poter dare esecuzione o prosecuzione alle finalità previste in quanto costituirebbe un trattamento illecito.",
      },
      {
        n: "10",
        title: "Categorie particolari di dati personali",
        body:
          "Lei potrebbe conferire al Titolare \"categorie particolari di dati personali\" ai sensi dell'art. 9 del Regolamento, cioè quei dati che rivelano \"l'origine razziale o etnica, le opinioni politiche, le convinzioni religiose o filosofiche, o l'appartenenza sindacale, nonché dati genetici, dati biometrici intesi a identificare in modo univoco una persona fisica, dati relativi alla salute o alla vita sessuale o all'orientamento sessuale della persona\". Tali categorie di dati potranno essere trattate solo previo Suo libero ed esplicito consenso.",
      },
      {
        n: "11",
        title: "Esistenza di un processo decisionale automatizzato, compresa la profilazione",
        body:
          "Il Titolare non adotta alcun processo decisionale automatizzato, compresa la profilazione, di cui all'articolo 22 del Regolamento.",
      },
      {
        n: "12",
        title: "Diritti dell'interessato",
        intro:
          "In ogni momento, Lei potrà esercitare, ai sensi degli articoli dal 15 al 22 del Regolamento, il diritto di:",
        items: [
          "chiedere la conferma dell'esistenza o meno di propri dati personali;",
          "ottenere le indicazioni circa le finalità del trattamento, le categorie dei dati personali, i destinatari o le categorie di destinatari a cui i dati personali sono stati o saranno comunicati e, quando possibile, il periodo di conservazione;",
          "ottenere la rettifica e la cancellazione dei dati;",
          "ottenere la limitazione del trattamento;",
          "ottenere la portabilità dei dati, ossia riceverli da un titolare del trattamento, in un formato strutturato, di uso comune e leggibile da dispositivo automatico, e trasmetterli ad un altro titolare del trattamento senza impedimenti;",
          "opporsi al trattamento in qualsiasi momento ed anche nel caso di trattamento per finalità di marketing diretto;",
          "opporsi ad un processo decisionale automatizzato relativo alle persone fisiche, compresa la profilazione;",
          "revocare il consenso in qualsiasi momento senza pregiudicare la liceità del trattamento basata sul consenso prestato prima della revoca;",
          "proporre reclamo a un'autorità di controllo.",
        ],
        footer:
          "Può esercitare i Suoi diritti con richiesta scritta inviata a I.E.P.E.M. S.r.l., all'indirizzo postale della sede legale o all'indirizzo iepem@iepem.it.",
      },
    ],
    place: "Perugia",
    date: "31/08/2026",
  },
};
